export class SnapshotDetails {
    ccKey: String;
    previousMonthValue: number;
    currentMonthValue: number;
    currentMonthTitle?:string;
    previousMonthTitle?:string;
}

export interface SnapPayload {
    distributorID:string;
    country:string;
    currentYear:string|number,
    month:string|number
}



// WEBPACK FOOTER //
// ./src/app/customerservice/interface/snapshot-details.ts